import { render, staticRenderFns } from "./videoBlock1.vue?vue&type=template&id=61bddba8&"
import script from "./videoBlock1.vue?vue&type=script&lang=js&"
export * from "./videoBlock1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports